import { render } from "./PainelTV.vue?vue&type=template&id=7500fadc"
import script from "./PainelTV.vue?vue&type=script&lang=js"
export * from "./PainelTV.vue?vue&type=script&lang=js"

import "./guiche.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__